<!-- Rendered inside the breadcrumb's vb-dialog, which owns the title + close. -->
<div class="reminders">
    <div class="reminders__section" *ngIf="reminders.length > 0">
        <p class="reminders__eyebrow">Your reminders</p>
        <ul class="reminders__list">
            <li
                class="reminders__row"
                *ngFor="let reminder of reminders"
                [class.is-editing]="
                    isEditing && reminder.id === currentReminder.id
                ">
                <div class="reminders__row-text">
                    <span class="reminders__row-time">
                        {{
                            convertMillisecondsToTime(reminder.notifyAtLabel!)
                        }}
                        {{ beforeLabel(reminder) }}
                    </span>
                    <span class="reminders__row-meta">
                        {{ methodLabel(reminder) }}
                    </span>
                </div>
                <div class="reminders__row-actions" *ngIf="!isEditing">
                    <vb-icon-button
                        icon="note"
                        label="Edit reminder"
                        tipAlign="right"
                        [size]="32"
                        (clicked)="editReminder(reminder)" />
                    <vb-icon-button
                        icon="close"
                        label="Delete reminder"
                        tipAlign="right"
                        [danger]="true"
                        [size]="32"
                        (clicked)="deleteReminder(reminder)" />
                </div>
            </li>
        </ul>
    </div>

    <div class="reminders__section" *ngIf="!isLoading">
        <p class="reminders__eyebrow">
            {{ isEditing ? "Edit reminder" : "New reminder" }}
        </p>
        <p class="reminders__hint" *ngIf="!allTimesUsed">
            We'll remind you about this auction at the time you pick before
            it opens or closes.
        </p>

        <ng-container *ngIf="!isEditing && !isAuctionStarted">
            <p class="reminders__field-label">Send me a reminder</p>
            <div class="reminders__chips">
                <vb-toggle-chip
                    *ngFor="let option of reminderOptions"
                    [small]="true"
                    [selected]="selectedOption === option.value"
                    (toggled)="onOptionSelect(option.value)">
                    {{ option.label }}
                </vb-toggle-chip>
            </div>
        </ng-container>

        <p class="reminders__field-label">{{ alertTimeFieldLabel }}</p>
        <div class="reminders__chips">
            <vb-toggle-chip
                *ngFor="let time of alertTimeOptions"
                [small]="true"
                [disabled]="time.unavailable"
                [selected]="currentReminder.notifyAtLabel === time.value"
                (toggled)="selectAlertTime(time.value)">
                <span
                    class="reminders__chip-label"
                    [class.is-unavailable]="time.unavailable"
                    >{{ convertMillisecondsToTime(time.value) }}</span
                >
            </vb-toggle-chip>
        </div>
        <p class="reminders__empty" *ngIf="allTimesUsed">
            No times left to choose from — every reminder time has already
            passed or is in use.
        </p>

        <ng-container *ngIf="!allTimesUsed">
            <p class="reminders__field-label">Notify me by</p>
            <div class="reminders__chips">
                <vb-toggle-chip
                    [small]="true"
                    [selected]="!!currentReminder.email"
                    (toggled)="toggleMethod('email')">
                    Email
                </vb-toggle-chip>
                <vb-toggle-chip
                    [small]="true"
                    [selected]="!!currentReminder.sms"
                    (toggled)="toggleMethod('sms')">
                    Text
                </vb-toggle-chip>
            </div>

            <p
                class="reminders__summary"
                *ngIf="formValid"
                [innerHTML]="getNotificationText()"></p>
        </ng-container>

        <div class="reminders__actions" *ngIf="isEditing || !allTimesUsed">
            <vb-button
                *ngIf="isEditing"
                variant="ghost"
                size="md"
                (clicked)="cancelEdit()">
                Cancel
            </vb-button>
            <vb-button
                *ngIf="isEditing"
                variant="primary"
                size="md"
                [disabled]="!formValid"
                (clicked)="updateReminder()">
                Update reminder
            </vb-button>
            <vb-button
                *ngIf="!isEditing"
                variant="primary"
                size="md"
                [disabled]="!formValid"
                (clicked)="saveReminder()">
                Save reminder
            </vb-button>
        </div>
    </div>
</div>
